define.alias("shared/components/shared/ui/social-set-switcher/social-set", "settings/components/shared/ui/social-set-switcher/social-set");